import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Row,
  Col,
} from "reactstrap";

const AccountSelectionModal = ({
  isOpen,
  toggle,
  accounts,
  selectedAccountID: controlledAccountID,
  onAccountSelect,
  onConfirm,
  onAcceptTerms,
  loading,
  hasTerms,
  termsDocument,
}) => {
  const [step, setStep] = useState(1);
  const [internalAccountId, setInternalAccountId] = useState(null);

  // Support both controlled (parent manages state) and uncontrolled (modal manages state) modes
  const isControlled = typeof onAccountSelect === "function";
  const selectedAccountID = isControlled ? controlledAccountID : internalAccountId;

  const handleAccountChange = (account_ID) => {
    if (isControlled) {
      onAccountSelect(account_ID);
    } else {
      setInternalAccountId(account_ID);
    }
  };

  const handleNext = () => {
    if (hasTerms) {
      setStep(2);
    } else {
      // Uncontrolled mode: pass accountId to onConfirm. Controlled mode: call without args.
      isControlled ? onConfirm() : onConfirm(selectedAccountID);
    }
  };

  const handleBack = () => {
    setStep(1);
  };

  const handleClose = () => {
    setStep(1);
    if (!isControlled) setInternalAccountId(null);
    toggle();
  };

  const handleAcceptTerms = () => {
    setStep(1);
    if (typeof onAcceptTerms === "function") {
      onAcceptTerms();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
    >
      {step === 1 ? (
        <>
          <ModalHeader toggle={handleClose}>Select Company for Registration</ModalHeader>
          <ModalBody style={{ minHeight: "35vh" }}>
            {loading ? (
              <div className="text-center py-4">
                <Spinner color="primary" />
                <p className="mt-2">Loading accounts...</p>
              </div>
            ) : (
              <div>
                <p className="mb-3">
                  Please select which Company you would like to register under for
                  this event:
                </p>
                {accounts && accounts.length > 0 ? (
                  <FormGroup style={{ maxWidth: "28rem" }}>
                    <Label for="accountSelect">Account</Label>
                    <Input
                      type="select"
                      id="accountSelect"
                      value={selectedAccountID ?? ""}
                      onChange={(e) => handleAccountChange(parseInt(e.target.value, 10))}
                      disabled={loading}
                    >
                      {accounts.map((account) => (
                        <option key={account.account_ID} value={account.account_ID}>
                          {account.accountName || "Unnamed Account"}
                          {account.isBusinessAccount === false ? " (Personal)" : ""}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                ) : (
                  <p className="text-danger">
                    No accounts found. Please contact support.
                  </p>
                )}
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={handleNext}
              disabled={!selectedAccountID || loading}
            >
              {hasTerms ? "Next" : "Register"}
            </Button>
          </ModalFooter>
        </>
      ) : (
        <>
          <ModalHeader>Accept Event's Terms and Conditions</ModalHeader>
          <ModalBody style={{ minHeight: "35vh", display: "flex", flexDirection: "column" }}>
            <Row className="mb-2">
              <Col xs={2} sm={2} md={2}>
                <i
                  style={{ fontSize: 40, color: "red" }}
                  className="fa fa-exclamation-circle"
                />
              </Col>
              <Col xs={10} sm={10} md={10}>
                The Terms and Conditions have changed. Please read the new version
                and accept to continue or you will not be able to register for the
                event.
              </Col>
            </Row>
            <div
              className="d-flex justify-content-center sun-editor-editable p-2 rounded w-100"
              style={{ flex: 1, overflow: "hidden" }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: termsDocument }}
                style={{ width: "100%", overflowY: "auto" }}
              ></div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleBack}>
              Back
            </Button>
            <Button className="btn btn-blue" onClick={handleAcceptTerms}>
              Accept
            </Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};

export default AccountSelectionModal;
